import React from 'react';
import { Button } from './ui/button';
import { Download, Star, Shield, Smartphone } from 'lucide-react';
import heroImage from './assets/image_hero_compress.png';

const HeroSection = () => {
  // const handleDownload = () => {
  //   //window.open('https://play.google.com/store/apps/details?id=com.mpointer.touchpad.bigphones', '_blank');
  //   gtag_report_conversion();
  // };

  return (
    <section className="relative pt-24 sm:pt-32 pb-16 sm:pb-24 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-white to-purple-50 opacity-70"></div>
      <div className="absolute top-20 right-0 w-96 h-96 bg-indigo-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Left Content */}
          <div className="space-y-8 ml-auto mr-auto pt-12">
            {/* Badge */}
            <div className="inline-flex items-center space-x-2 bg-indigo-100 text-indigo-700 px-4 py-2 rounded-full text-sm font-semibold">
              <Star className="w-4 h-4 fill-indigo-600" />
              <span>Trusted by thousands of users</span>
            </div>

            {/* Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
              Control Your Phone
              <span className="block bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mt-2">
                With One Hand
              </span>
            </h1>

            {/* Description */}
            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
              The ultimate touchpad app for Android.
              <br/>Navigate your entire screen effortlessly.
              <br/>Perfect for large phones and tablets.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              {/* <Button
                onClick={() => document.getElementById('download')?.scrollIntoView({ behavior: 'smooth' })}
                size="lg"
                className="bg-indigo-600 hover:bg-indigo-700 text-white shadow-xl hover:shadow-2xl transition-all text-lg px-8 py-6 group">

                <Download className="w-5 h-5 mr-2 group-hover:animate-bounce" />
                Download Free
              </Button> */}
              <Button
                onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
                size="lg"
                variant="outline"
                className="border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-50 hover:text-indigo-700 text-lg px-8 py-6">

                Learn More
              </Button>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 pt-4">
              <div className="flex items-center space-x-2">
                <div className="w-12 h-12 bg-indigo-100 rounded-xl flex items-center justify-center">
                  <Smartphone className="w-6 h-6 text-indigo-600" />
                </div>
                <div>
                  <p className="!font-bold !text-2xl text-gray-900">1M+</p>
                  <p className="text-sm text-gray-600">Downloads</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center">
                  <Star className="w-6 h-6 text-purple-600 fill-purple-600" />
                </div>
                <div>
                  <p className="!font-bold !text-2xl text-gray-900">4.2+</p>
                  <p className="text-sm text-gray-600">Rating</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                  <Shield className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">100%</p>
                  <p className="text-sm text-gray-600">Safe</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative">
            <div className="relative hero-image z-10 rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <img
                src={heroImage}
                alt="Touchpad App"
                className="w-full h-auto object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-indigo-900/30 to-transparent"></div>
            </div>
            {/* Floating Cards */}
            {/* <div className="absolute -top-4 -right-4 bg-white rounded-2xl shadow-xl p-4 animate-float">
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-sm font-semibold text-gray-900">Active Now</span>
              </div>
            </div>
            <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl shadow-xl p-4 animate-float animation-delay-1000">
              <p className="text-sm font-semibold text-gray-900">One-Handed Mode</p>
              <p className="text-xs text-gray-600">Activated</p>
            </div> */}
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;